export const COLORS = {
    primary: '#4b65a0',
    secondary: '#ffffff',
    extra: '',
    background_primary: 'white',
    background_secondary: 'rgba(145, 158, 171, 0.12)',
    background_extra: '#212B36',
    sidebar_background_active: 'rgba(32, 101, 209, 0.16)',
    sidebar_text_active: '#4b65a0',
    usermenu_background: '#fff',
    text_primary: 'rgb(99, 115, 129)',
    text_secondary: '#fff'
}